/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import LadeTypenUtil from "../../Cloud/DomainDrivenDesign/Queries/LadeTypenUtil";
import { Feld, Typ } from "../../Cloud/DomainDrivenDesign/Queries/PromiseLadeTypen";
import { useAppContext } from "../Components/AppContext";
import IAppContext from "../Components/AppContext/IAppContext";
import StringUtil from "../Utils/StringUtil";

export default class CommandInputNullifier {
    private readonly _appContext: IAppContext;

    constructor() {
        this._appContext = useAppContext();
    }

    public async nullify(typBezeichung: string, input: any): Promise<any> {
        const typen = await this._appContext.typen;
        const typ = LadeTypenUtil.findeTyp(typen, typBezeichung);
        const nullifiedInput = { ...input };
        this.nullifyInternal(typen, typ, nullifiedInput);
        return nullifiedInput;
    }

    public static nullify(value: string | undefined | null): string | null {
        if (value === null || value === undefined || value.length <= 0) {
            return null;
        }

        return value;
    }

    private nullifyInternal(typen: Typ[], typ: Typ, nullifiedInput: any) {
        const inputPropertyNames = Object.getOwnPropertyNames(nullifiedInput).sort();
        for (const propertyName of inputPropertyNames) {
            const feld = LadeTypenUtil.findeFeld(typ, propertyName);
            const value = nullifiedInput[propertyName];
            if (typeof value === "string" && StringUtil.isEmpty(value)) {
                nullifiedInput[propertyName] = null;
            }

            if (value && feld.hatGraphQLTypName) {
                this.nullifyUntertyp(typen, feld, value);
            }
        }
    }

    private nullifyUntertyp(typen: Typ[], feld: Feld, value: any) {
        if (feld.istObjekt) {
            const typ = LadeTypenUtil.findeTyp(typen, feld.graphQLTypName);
            this.nullifyInternal(typen, typ, value);
        } else if (feld.istListe) {
            for (const valueItem of value) {
                const typ = LadeTypenUtil.findeTyp(typen, feld.graphQLTypName);
                this.nullifyInternal(typen, typ, valueItem);
            }
        }
    }
}
